// export default ProductTable;
import React from 'react';
import DataTable, { TableColumn } from 'react-data-table-component';
import Buttons from '../../components/Button';
import { Product } from '../../interfaces/adminproduct';
import SearchInput from '../../components/SearchInput';
import NoData from '../../components/NoData';
import './ProductTable.css';

interface ProductTableProps {
  myrole : "admin" | "vendor";
  products: Product[];
  categories: any[];
  searchTerm: string;
  setSearchTerm: React.Dispatch<React.SetStateAction<string>>;
  handleEdit: (product: Product) => void;
  handleDelete: (id: string) => void;
  openModal: (product: Product) => void;
}

const ProductTable: React.FC<ProductTableProps> = ({
  myrole,
  products,
  categories,
  searchTerm,
  setSearchTerm,
  handleEdit,
  handleDelete,
  openModal,
}) => {
  const columns: TableColumn<Product>[] = [
    {
      name: 'Image',
      cell: (row) =>
        row.images?.[0] ? (
          <img
            src={row.images[0]}
            alt={row.name}
            onClick={() => openModal(row)}
            className="cursor-pointer object-cover rounded"
            style={{
              width: '32px',
              height: '32px',
              maxWidth: '32px',
              maxHeight: '32px',
            }}
          />
        ) : (
          <span className="text-gray-400">No Image</span>
        ),
      width: '60px',
    },

    {
      name: 'Product Name',
      cell: (row) => (
        <button
          className="text-link"
          title={row.description}
          onClick={() => openModal(row)}
        >
          {row.name}
        </button>
      ),
      sortable: true,
      grow: 2,
    },
    {
      name: 'Category',
      selector: (row) =>
        categories.find((c) => c.id === row.categoryId)?.name || 'N/A',
      sortable: true,
    },
    {
      name: 'Reward',
      cell: (row) =>
        row.rewardFlag ? (
          <span className="badge_table reward-enabled">🎖️ Enabled</span>
        ) : (
          <span className="badge_table reward-disabled">Disabled</span>
        ),
      sortable: false,
    },

    {
      name: 'Status',
      cell: (row) =>
        row.status === "Approved" ? (
          <span className="badge_table status-approved">🎖️ Approved</span>
        ) : (
          <span className="badge_table status-disabled">❌ No</span>
        ),
      sortable: true,
    },

    {
      name: 'Stock',
      cell: (row) => {
        let stockClass = row.stockQuantity > 10
          ? 'stock-high'
          : row.stockQuantity > 0
            ? 'stock-medium'
            : 'stock-low';

        return (
          <span className={`badge_table ${stockClass}`}>
            {row.stockQuantity}
          </span>
        );
      },
      sortable: true,
    },

    {
      name: 'Final Price',
      cell: (row) => {
        // const price = row.price ?? 0;
        // const gst = row.gst ?? 0;
        // const margin = row.marginPrice ?? 0;
        // const discount = row.discountedPrice ?? 0;
        // const originalTotal = price + margin;
        // const finalPrice = originalTotal - discount;

        const price = row.price ?? 0;

        const marginPercent = row.marginPrice ?? 0;
        const discountPercent = row.discountedPrice ?? 0;
        const gstPercent = row.gst ?? 0;

        // 1. Add margin %
        const priceWithMargin = price + (price * marginPercent / 100);

        // 2. Apply discount %
        const priceAfterDiscount = priceWithMargin - (priceWithMargin * discountPercent / 100);

        // 3. Add GST %
        const finalPrice = priceAfterDiscount + (priceAfterDiscount * gstPercent / 100);

        

        return finalPrice ? (
          <div className="flex flex-col">
            <span className="text-black font-semibold">
              ₹{finalPrice.toFixed(2)}
            </span>
          </div>
        ) : (
          <span>₹{finalPrice.toFixed(2)}</span>
        );
      },
      sortable: true,
    }
    ,
    {
      name: 'Actions',
      cell: (row) => (
        <div className="flex gap-2">
          <Buttons
            text="Edit"
            onClick={() => handleEdit(row)}
            variant="edit"
          />
          {myrole === "admin" && (
            <Buttons
              text="Delete"
              onClick={() => handleDelete(row.id)}
              variant="delete"
            />
          )}

        </div>
      ),
    },
  ];

  return (
    <div className="product_table">
      <h2 className="text-xl font-semibold mb-3">Products List</h2>
      <SearchInput searchText={searchTerm} setSearchText={setSearchTerm} />
      <DataTable
        keyField="id"
        columns={columns}
        data={products.filter((p) => {
          const categoryName =
            categories.find((c) => c.id === p.categoryId)?.name?.toLowerCase() || '';
          return (
            p.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            p.description?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            categoryName.includes(searchTerm.toLowerCase())
          );
        })}

        pagination
        paginationPerPage={5}
        highlightOnHover
        noDataComponent={<NoData message="No Products Found" />}
      />
    </div>
  );
};

export default ProductTable;
